export enum appLinks {
  MAIN_PAGE = '/',
  LOGIN = '/login',
  SIGN_UP = '/sign-up',
  LOG_OUT = '/log-out',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  CHANGE_PASSWORD = '/change-password',
  ACCOUNT = '/account',
  PRICING = '/pricing',
  SUBSCRIPTION_SUCCESS = '/subscription-success',
  REGISTER_SUCCESS = '/register-success',
  TERMS = '/terms',
  PRIVACY = '/privacy',
  HELP = '/help',
  DETAILS = '/details',
  ADD = '/add',
  EDIT = '/edit',
}

/** Route patterns that carry a contact id (see plan item H). */
export const DETAILS_ROUTE_PATTERN = `${appLinks.DETAILS}/:id`;
export const EDIT_ROUTE_PATTERN = `${appLinks.EDIT}/:id`;
export const contactDetailsLink = (id: number | string) => `${appLinks.DETAILS}/${id}`;
export const contactEditLink = (id: number | string) => `${appLinks.EDIT}/${id}`;

export interface IRouteElement {
  link: string;
  component: JSX.Element;
}

export enum contactFields {
  NAME = 'Name',
  EMAIL = 'Email',
  PROFILE_URL = 'URL',
  WHERE_WE_MET = 'Met',
  CONTEXT = 'Context',
  NOTES = 'Notes',
  TAGS = 'Tags',
}
